import Types from "./Types";

const INITIAL_STATE = {
  subjects: [],
  subject: {},
  isLoading: false,
  count: "",
};

export default function superadminSubjects(state = INITIAL_STATE, action) {
  const { type, payload } = action;
  switch (type) {
    case Types.GET_SUPERADMIN_SUBJECTS_SUCCESS: {
      return {
        ...state,
        subjects: payload.data,
        count: payload.data.length,
      };
    }

    case Types.GET_SUPERADMIN_SUBJECT_SUCCESS: {
      return {
        ...state,
        subject: payload,
      };
    }

    case Types.EDIT_SUPERADMIN_SUBJECT_SUCCESS: {
      console.log(payload, "red");
      let data = payload.data;
      const subjects = state.subjects;
      let idx = 0;
      subjects.forEach((table, index) => {
        if (table.id === data.id) {
          idx = index;
          return;
        }
      });

      subjects[idx] = data;
      return {
        ...state,
        subjects: subjects,
      };
    }

    case Types.RESTRICT_SUPERADMIN_SUBJECT_SUCCESS: {
      let data = payload.data;
      const subjects = state.subjects;
      let idx = 0;
      subjects.forEach((table, index) => {
        if (table.id === data.id) {
          idx = index;
          return;
        }
      });

      subjects[idx] = data;
      return {
        ...state,
        subjects: subjects,
      };
    }
    case Types.ASQUARA_SUPERADMIN_SUBJECT_SUCCESS: {
      let data = payload.data;
      const subjects = state.subjects;
      let idx = 0;
      subjects.forEach((table, index) => {
        if (table.id === data.id) {
          idx = index;
          return;
        }
      });

      subjects[idx] = data;
      return {
        ...state,
        subjects: subjects,
      };
    }

    case Types.ACTIVE_SUPERADMIN_SUBJECT_SUCCESS: {
      let data = payload.data;
      const subjects = state.subjects;
      let idx = 0;
      subjects.forEach((table, index) => {
        if (table.id === data.id) {
          idx = index;
          return;
        }
      });

      subjects[idx] = data;
      return {
        ...state,
        subjects: subjects,
      };
    }

    // create
    case Types.CREATE_SUPERADMIN_SUBJECT_SUCCESS: {
      const data = payload.data.data;
      let newArray = state.subjects.slice();
      let index = state.subjects.length + 1;
      newArray.splice(index, 0, data);
      return {
        ...state,
        subjects: newArray,
        count: state.count + 1,
      };
    }
    case Types.ADD_SUPERADMIN_SUBJECTS_LOADING: {
      return {
        ...state,
        isLoading: payload,
      };
    }

    case Types.DELETE_SUPERADMIN_SUBJECT_SUCCESS: {
      const newsubjects = state.subjects.filter((item) => item.id !== payload);
      return {
        ...state,
        subjects: newsubjects,
        count: state.count - 1,
      };
    }
    default: {
      return state;
    }
  }
}
